import {reducerWithInitialState} from "typescript-fsa-reducers";
import { tableInitialState, deepCopyTableThingyState } from "../typing/tablestates";
import {TableThingyActions} from "../actions/table_actions";

export default reducerWithInitialState(tableInitialState)
        .case(TableThingyActions.resetData, (state,payload) => {
            const deepCopy=deepCopyTableThingyState(state);
            if (payload.data){
                deepCopy.model.newslist=payload.data;
                deepCopy.model.newslist.forEach(element => {
                element.todelete = false;
                element.selected = false;
                /// Todo:Maybe isnert a autoamted selction process for "good quality news"
               });
               deepCopy.view.loaded = true;
            }
            return deepCopy;
        })
        .case(TableThingyActions.toogleEntry, (state, payload) => {
            const deepCopy=deepCopyTableThingyState(state);
            console.log(payload)
            deepCopy.model.newslist.forEach(element => {
                if (element.uuid === payload.uuid)
                {
                    if (payload.what === "delete")
                        {
                            element.todelete = !element.todelete
                            if(element.todelete === true)
                            {
                                element.selected = false;
                            }
                        }
                    if (payload.what === "select")
                        {
                            element.selected = !element.selected
                            if(element.selected === true)
                            {
                                element.todelete = false;
                            }
                        }
                }
            });
            return deepCopy;
        }
        )
        ;